import type {
  AuthorizedSession,
  SystemSession,
  SystemSessionJson,
} from '@mntn-dev/auth-types'
import {
  OrganizationId,
  type TeamId,
  UserId,
  type UserPrincipalDomainQueryModel,
  UserUrn,
} from '@mntn-dev/domain-types'
import { createPermissions } from './permissions/create-permissions.ts'

export const SystemUserId = UserId.Empty

export const SystemUser = <const>{
  emailAddress: 'system@quickframe.com',
  firstName: 'System',
  lastName: 'User',
  displayName: 'System User',
  initials: 'SU',
  authConnection: 'Username-Password-Authentication',
  isActive: true,
  userId: SystemUserId,
  userUrn: UserUrn(SystemUserId),
  teamIds: [] as TeamId[],
  organizationId: OrganizationId.Empty,
  organizationType: 'system',
}

export type SystemUser = typeof SystemUser

export type UserPrincipalOrSystemUser =
  | UserPrincipalDomainQueryModel
  | SystemUser

export const isSystemUser = (
  user: Pick<UserPrincipalOrSystemUser, 'userId' | 'organizationType'>
): user is SystemUser => {
  const systemUser = user as SystemUser
  return (
    systemUser?.userId === SystemUser.userId &&
    systemUser?.organizationType === SystemUser.organizationType
  )
}

export const systemSessionFromAuthorizedSession = (
  session: AuthorizedSession
): SystemSession => {
  const systemSession: SystemSession = {
    ...session,
    principal: {
      ...session.principal,
      user: SystemUser,
      ...createPermissions({ organizationType: SystemUser.organizationType }),
    },
  } as const

  return systemSession
}

export const rehydrateSystemSession = (
  session: SystemSession | SystemSessionJson
): SystemSession => {
  const systemSession: SystemSession = {
    ...session,
    principal: {
      ...session.principal,
      ...createPermissions({
        organizationType: session.principal.user.organizationType,
      }),
    },
  } as const

  return systemSession
}
